import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

export const getMyVacationInfo = async (salusUserId) => {
  const response = await axios.get(
    `${baseUrl}/salus-vacation/me/${salusUserId}`,
    {
      params: { salusUserId },
    },
  )
  return response.data
}

// 연차 신청

export const applyVacation = async (payload) => {
  const response = await axios.post(`${baseUrl}/salus-vacation/apply`, payload)
  return response.data
}

// 나의 연차 히스토리
export const getMyVacationHistory = async (salusUserId) => {
  const response = await axios.get(
    `${baseUrl}/salus-vacation/users/${salusUserId}/histories/active`,
    {
      params: { salusUserId },
    },
  )
  return response.data
}

// 연차 취소
export const cancelVacation = async (historyId, userId) => {
  const response = await axios.patch(
    `${baseUrl}/salus-vacation/cancel/${historyId}?userId=${userId}`,
  )
  return response.data
}

// --------------------------
// --------------------------
// 🔥 연차 관리자 페이지
// --------------------------
// --------------------------
export const getTeamByStudioGroup = async ({
  studioGroupId,
  page = 0,
  size = 5,
  sort = 'id,DESC',
}) => {
  const params = {
    page,
    size,
    sort,
  }

  // Only include studioGroupId if it's not null/undefined
  if (studioGroupId !== null && studioGroupId !== undefined) {
    params.studioGroupId = studioGroupId
  }

  const response = await axios.get(`${baseUrl}/salus-vacation/employee-list`, {
    params,
  })

  return response.data
}

// 스튜디오 목록 조회
export const getStudioList = async () => {
  const response = await axios.get(`${baseUrl}/salus-user/studios`)
  return response.data
}

// 연차 신청 리스트
export const getVacationRequestList = async ({
  studioGroupId,
  page = 0,
  size = 5,
  sort = 'id,DESC',
}) => {
  const params = {
    page,
    size,
    sort,
  }

  // Only include studioGroupId if it's not null/undefined
  if (studioGroupId !== null && studioGroupId !== undefined) {
    params.studioGroupId = studioGroupId
  }

  const response = await axios.get(`${baseUrl}/salus-vacation/pending-list`, {
    params,
  })
  return response.data
}

export const getVacationRequestDetail = async (historyId) => {
  const response = await axios.get(
    `${baseUrl}/salus-vacation/histories/${historyId}`,
  )
  return response.data
}

export const approveVacation = async (historyId, param) => {
  const response = await axios.patch(
    `${baseUrl}/salus-vacation/approve/${historyId}`,
    param,
  )
  return response.data
}

export const getVacationSettlementList = async ({
  page = 0,
  size = 5,
  sort = 'id,DESC',
}) => {
  const params = {
    page,
    size,
    sort,
  }

  const response = await axios.get(
    `${baseUrl}/salus-vacation/settlement-list`,
    {
      params,
    },
  )
  return response.data
}

export const updatePayoutStatus = async (payload) => {
  // {
  //   "userId": 0,
  //   "settlementId": 0
  // }
  const response = await axios.post(`${baseUrl}/salus-vacation/payout`, payload)
  return response.data
}

export const getVacationSettlementDetail = async (settlementId) => {
  const response = await axios.get(
    `${baseUrl}/salus-vacation/settlements/${settlementId}`,
  )
  return response.data
}
